import { ToggleButtonGroup, ToggleButton } from '@mui/material'
import { themeColors } from '@app/constants'
import { ReactNode } from 'react'

export interface ToggleButtonOption {
	value: string
	label: ReactNode
}

interface CustomToggleButtonGroupProps {
	value: string
	onChange: (value: any) => void
	options: ToggleButtonOption[]
	fullWidth?: boolean
	size?: 'small' | 'medium' | 'large'
}

export default function CustomToggleButtonGroup({
	value,
	onChange,
	options,
	fullWidth = true,
	size = 'small',
}: CustomToggleButtonGroupProps) {
	return (
		<ToggleButtonGroup
			value={value}
			exclusive
			onChange={(_event, newValue) => {
				if (newValue !== null) {
					onChange(newValue)
				}
			}}
			fullWidth={fullWidth}
			size={size}
			sx={{
				height: '53px',
				backgroundColor: 'white',
				border: '1px solid rgba(0, 0, 0, 0.23)',
				borderRadius: '4px',
				'& .MuiToggleButtonGroup-grouped': {
					border: 0,
					'&:not(:first-of-type)': {
						borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
					},
				},
				'& .MuiToggleButton-root': {
					'&.Mui-selected': {
						backgroundColor: themeColors.agitronDark,
						color: 'white',
						'&:hover': {
							backgroundColor: themeColors.agitronDark,
						},
					},
				},
			}}
		>
			{options.map((option) => (
				<ToggleButton key={option.value} value={option.value}>
					{option.label}
				</ToggleButton>
			))}
		</ToggleButtonGroup>
	)
}
